import Constants from "./DLConstants";

let initialState = {
  ImagineAddress: [],
  ImagineData: [],
  ImagingCentreData: [],
  ImagingCheapPackage: [],
  ImagingSubCentreList: [],
  ImagingNearbyCitiesList: [],
  DLdetialForm: {},
};

export default function DLReducers(state = initialState, action) {
  let newState = Object.assign({}, state);
  switch (action.type) {
    case Constants.ACTIONS.GET_IMAGINE_ADD_SUCCESS:
      newState.ImagineAddress = action.payload;
      break;
    case Constants.ACTIONS.GET_IMAGINE_PACK_DATA_SLUG_SUCCESS:
      newState.ImagingCentreData = action.payload;
      break;
    case Constants.ACTIONS.GET_IMAGINE_PACK_DATA_ID_SUCCESS:
      newState.ImagingCheapPackage = action.payload;
      break;
    case Constants.ACTIONS.GET_SUB_CENTER:
      newState.ImagingSubCentreList = action.payload;
      break;
      case Constants.ACTIONS.GET_NEARBY_CITIES:
      newState.ImagingNearbyCitiesList = action.payload;
      break;
    case Constants.ACTIONS.GET_IMAGINE_DATA_SUCCESS:
      newState.ImagineData = action.payload;
      break;
    case Constants.ACTIONS.POST_LEAD_USER_SUCCESS:
      newState.DLdetialForm = action.payload;
      break;
    default:
      break;
  }
  return newState;
}
